import actionTypes from 'dashboard/actions/announcements/action-types';
import { addAnnouncement, deleteAnnouncement, getActiveAnnouncements, togglePinAnnouncement } from 'dashboard/reducers/announcements/utils';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS:
      return getActiveAnnouncements([...action.items], action.lotteryTime, action.locale);
    case actionTypes.TOGGLE_PIN_ANNOUNCEMENTS:
      return togglePinAnnouncement([...state], action.index, action.locale, action.locales);
    case actionTypes.DELETE_ACTIVE_ANNOUNCEMENT:
      return deleteAnnouncement([...state], action.index);
    case actionTypes.ADD_ACTIVE_ANNOUNCEMENT:
      return addAnnouncement([...state], action.announcement, action.locale);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/announcements/active.js